/* ========================================================================== *\
___________       __         .__
\_   _____/ _____/  |________|__| ____
 |    __)_ /    \   __\_  __ \  |/  _ \
 |        \   |  \  |  |  | \/  (  <_> )
/_______  /___|  /__|  |__|  |__|\____/
        \/     \/
\* ========================================================================== */
// สถานะ "เลือกหลายภาพ → ดาวน์โหลด zip" + ดาวน์โหลดทีละภาพ ใช้ร่วม 4 หน้าผลงาน (A2 · 25 ต.ค. 2569)
// เก็บรายการที่เลือกเป็น { id: { id, url, name, folder? } } จึงข้ามหน้า (แบ่งหน้า) ได้
import { useRef, useState } from 'react';
import { downloadImage, downloadZip, zipDoneText } from './imageDownload';

const FAIL = 'ดาวน์โหลดไม่สำเร็จ ลองอีกครั้ง';

export default function useBulkDownload() {
  const [on, setOn] = useState(false);
  const [sel, setSel] = useState({});
  const [busy, setBusy] = useState(false);
  const [progress, setProgress] = useState(null);
  /* ข้อมูลล่าสุดของแต่ละภาพจากการ render ครั้งล่าสุด — ย้าย/เอาโลโก้ออกหลังติ๊ก URL ของภาพเปลี่ยน
     (รีเช็ค 26 ต.ค.: เดิม zip ใช้ URL ตอนติ๊ก ไฟล์เก่าถูกลบแล้ว โหลดไม่ได้ทั้งชุด) */
  const latest = useRef({});
  const oneBusy = useRef(false);

  const toggle = (item) =>
    setSel((prev) => {
      const next = { ...prev };
      if (next[item.id]) delete next[item.id];
      else next[item.id] = item;
      return next;
    });
  const addAll = (items) =>
    setSel((prev) => {
      const next = { ...prev };
      items.forEach((it) => {
        next[it.id] = it;
      });
      return next;
    });
  const clear = () => setSel({});
  const toggleMode = () => {
    setOn((v) => !v);
    setSel({});
  };

  /* zip ทุกภาพที่เลือก · ชื่อ zip ไม่ต้องใส่ .zip · notify = showNotify ของหน้านั้น */
  const run = async (zipName, notify) => {
    const items = Object.values(sel).map((it) => latest.current[it.id] || it);
    if (!items.length || busy) return;
    setBusy(true);
    setProgress([0, items.length]);
    try {
      const res = await downloadZip(items, zipName, (done, total) => setProgress([done, total]));
      notify(zipDoneText(res), res.skipped.length ? 'warning' : 'success');
      setOn(false);
      setSel({});
    } catch (e) {
      notify(FAIL, 'error');
    } finally {
      setBusy(false);
      setProgress(null);
    }
  };

  /* กดซ้ำระหว่างโหลดไฟล์ใหญ่ไม่โหลดซ้ำ */
  const one = (url, name, notify) => {
    if (oneBusy.current) return Promise.resolve();
    oneBusy.current = true;
    return downloadImage(url, name)
      .catch(() => notify(FAIL, 'error'))
      .finally(() => {
        oneBusy.current = false;
      });
  };

  /* prop select ของ ReviewThumb · null เมื่อไม่ได้อยู่ในโหมดเลือก */
  const selectProps = (item, label) => {
    latest.current[item.id] = item;
    return on ? { checked: Boolean(sel[item.id]), onToggle: () => toggle(item), label } : null;
  };

  return {
    on,
    count: Object.keys(sel).length,
    busy,
    progress,
    toggleMode,
    isSelected: (id) => Boolean(sel[id]),
    addAll,
    clear,
    run,
    one,
    selectProps,
  };
}
